module.exports = __webpack_public_path__ + "img/logo-EAC6.45f91d70.png";